import { Grid, TextField, FormHelperText, MenuItem, Tooltip, InputAdornment } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import React, { useContext, useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import AuthContext from './../../authContext';
import { checkHourisPast } from './../../utils/helpers';
import disablePrevDateByHour from '../../utils/Date/disablePrevDateByHour'
import classes from './../../pages/createOrder/index.module.scss'
import warehousesRepository from 'client-sdk/src/Repository/warehouses-repository';
import JalaliUtils from '@date-io/jalaali';
import getTomorrowDate from '../../utils/Date/getTomorrowDate';
import env from "client-sdk/src/enviroments/enviroment"

const deliveryTimes = {
    fulfillmentService: [
        {
            value: '09-12',
            label: '9 الی 12',
            disable: "9"
        },
        {
            value: '12-15',
            label: '12 الی 15',
            disable: "12"
        },
        {
            value: '15-18',
            label: '15 الی 18',
            disable: "15"
        },
        {
            value: '18-21',
            label: '18 الی 21',
            disable: "18"
        },
    ],
    courier: [
        {
            value: '09-15',
            label: '9 الی 15',
            disable: "0"
        },
        {
            value: '15-21',
            label: '15 الی 21',
            disable: "15"
        }
    ],
    vip: [
        {
            value: '08-10',
            label: '8 الی 10',
            disable: "08"
        },
        {
            value: '09-11',
            label: '9 الی 11',
            disable: "09"
        },
        {
            value: '10-12',
            label: '10 الی 12',
            disable: "10"
        },
        {
            value: '11-13',
            label: '11 الی 13',
            disable: "11"
        },
        {
            value: '12-14',
            label: '12 الی 14',
            disable: "12"
        },
        {
            value: '13-15',
            label: '13 الی 15',
            disable: "13"
        },
        {
            value: '14-16',
            label: '14 الی 16',
            disable: "14"
        },
        {
            value: '15-17',
            label: '15 الی 17',
            disable: "15"
        },
        {
            value: '16-18',
            label: '16 الی 18',
            disable: "16"
        },
    ]
}


function OrderInputs(props: any) {
    const authContext = useContext(AuthContext);
    const { form, cod, isFulfillmentService, deliveryLocationType, editMode } = props
    const {
        errors,
        setValue,
        getValues,
        register,
        control,
        reset,
        watch
    } = form
    const values = getValues();
    const [originOptions, setOriginOptions] = useState<any>([]);

    useEffect(() => {
        // fetchWarehouses().then(res => setOriginOptions(res));
        setOriginOptions(env.warehouses)
        setValue("origin", env.warehouses[0].id)
    }, []);

    useEffect(() => {
        if (isFulfillmentService || deliveryLocationType) {
            setValue("customerProvince", "تهران")
            setValue("customerCity", "تهران")
        } else {
            setValue("customerProvince", "")
            setValue("customerCity", "")
        }
    }, [isFulfillmentService, deliveryLocationType]);

    useEffect(() => {
        if (values.deliveryDate || !editMode) {
            deliveryTypeChange()
        }
    }, [watch('deliveryType')]);

    useEffect(() => {
        if (values.deliveryDate && !editMode) {
            setValue('deliveryTime', '');
        }
    }, [values.deliveryDate]);

    const handleDisableTime = (hour: number) => {
        return (
            checkHourisPast(hour, watch("deliveryDate"))
        );
    };

    const calculateMinDate = () => {
        if (isFulfillmentService && values.deliveryType == "COURIER") {
            return getTomorrowDate()
        }
        if (isFulfillmentService && values.deliveryType == "VIP") {
            return disablePrevDateByHour(12)
        }
        if (deliveryLocationType && values.deliveryType == "COURIER") {
            return disablePrevDateByHour(10)
        }
        if (deliveryLocationType && values.deliveryType == "VIP") {
            return disablePrevDateByHour(16)
        }
        if (isFulfillmentService && deliveryLocationType) {
            return disablePrevDateByHour(8)
        }
        if (values.deliveryType == "COURIER") {
            return disablePrevDateByHour(10)
        }
        if (values.deliveryType == "VIP") {
            return disablePrevDateByHour(16)
        }
        if (values.deliveryType == "VVIP") {
            return disablePrevDateByHour(16)
        }
        return disablePrevDateByHour(10);
    }

    const deliveryTypeChange = () => {
        setValue('deliveryDate', calculateMinDate())
        setValue('deliveryTime', '')
    };

    return (
        <>
            <Grid container direction='column' justifyContent='space-between' item xs={12} md={3} lg={3} >
                <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                        <Controller
                            name="trackingCode"
                            label="کد پیگیری"
                            control={control}
                            rules={{
                                required: true,
                                pattern: /^[A-Za-z\d\-_]+$/,
                                minLength: 3,
                            }}
                            as={
                                <TextField
                                    type="search"
                                    variant="outlined"
                                    fullWidth
                                    id="trackingCode"
                                    name="trackingCode"
                                    disabled={editMode}
                                    // label="کدپیگیری"
                                    error={
                                        !!errors.trackingCode && !!errors.trackingCode
                                    }
                                // InputProps={{
                                //     endAdornment: (
                                //         <InputAdornment position="end">
                                //             <Tooltip title="کد دلخواه و منحصر به فرد برای هر سفارش که می‌توانید از طریق آن سفارش خود را در مراحل مختلف پیگیری نمایید">
                                //                 <Icon
                                //                     path={mdiInformationOutline}
                                //                     size={1}
                                //                     color={theme.palette.primary.main}
                                //                     className={classes.icon}
                                //                 />
                                //             </Tooltip>
                                //         </InputAdornment>
                                //     ),
                                // }}
                                />
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.trackingCode?.type === 'required' &&
                                'کدپیگیری الزامی میباشد'}
                        </FormHelperText>
                        <FormHelperText error focused>
                            {errors?.trackingCode?.type === 'minLength' &&
                                'کد پیگیری حداقل 3 کاراکتر می باشد'}
                        </FormHelperText>
                    </div>
                </div>
                <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                        <Controller
                            name="packageCount"
                            label="تعداد بسته"
                            control={control}
                            rules={{
                                required: true,
                            }}
                            as={
                                <TextField
                                    type="search"
                                    variant="outlined"
                                    fullWidth
                                    id="packageCount"
                                    name="packageCount"
                                    // label="کدپیگیری"
                                    error={
                                        !!errors.packageCount && !!errors.packageCount
                                    }
                                />
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.packageCount?.type === 'required' &&
                                'تعداد بسته الزامی میباشد'}
                        </FormHelperText>
                    </div>
                </div>
            </Grid>
            <Grid container direction='column' justifyContent='space-between' item xs={12} sm={3} md={3} lg={3} >
                <MuiPickersUtilsProvider
                    utils={JalaliUtils}
                    locale="fa"
                >
                    <Controller
                        rules={{ required: true }}
                        name="deliveryDate"
                        control={control}
                        as={
                            <DatePicker
                                inputVariant="outlined"
                                id="deliveryDate"
                                name="deliveryDate"
                                label="* تاریخ تحویل سفارش"
                                format="jYYYY/jMM/jDD"
                                minDate={calculateMinDate()}
                                fullWidth
                                disablePast
                                autoOk
                                okLabel="تأیید"
                                cancelLabel="لغو"
                                defaultValue={null}
                                disabled={values.deliveryType == ""}
                                value={values.deliveryDate}
                                onChange={() => setValue('deliveryTime', '')}
                                error={errors.hasOwnProperty('deliveryDate')}
                                helperText={
                                    errors.deliveryDate &&
                                    errors.deliveryDate.message
                                }
                            />
                        }
                    />
                    <FormHelperText error focused>
                        {errors.deliveryDate &&
                            'تاریخ تحویل سفارش الزامی میباشد'}
                    </FormHelperText>
                </MuiPickersUtilsProvider>
                <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                        <Controller
                            rules={{ required: true }}
                            style={{ width: '100%' }}
                            control={control}
                            name="packageCode"
                            label="اندازه بسته"
                            as={
                                <TextField
                                    variant="outlined"
                                    select
                                    fullWidth
                                    disabled={values.deliveryType == ""}
                                    error={
                                        !!errors.packageCode && !!errors.packageCode
                                    }
                                >
                                    <MenuItem value={'1'} data-cy="firstSize">
                                        {'پاکت'}
                                    </MenuItem>
                                    <MenuItem value={'2'} data-cy="secondSize">
                                        {'کوچک'}
                                    </MenuItem>
                                    <MenuItem value={'3'} data-cy="thirdSize">
                                        {'متوسط'}
                                    </MenuItem>
                                    <MenuItem value={'4'} data-cy="fourthSize">
                                        {'بزرگ'}
                                    </MenuItem>
                                    <MenuItem value={'5'} data-cy="fifthSize">
                                        {'پالت'}
                                    </MenuItem>
                                </TextField>
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.packageCode &&
                                ' اندازه بسته الزامی میباشد'}
                        </FormHelperText>
                    </div>
                </div>
            </Grid>
            <Grid container direction='column' justifyContent='space-between' item xs={12} sm={3} md={3} lg={3} >
                <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                        <Controller
                            rules={{ required: true }}
                            style={{ width: '100%' }}
                            control={control}
                            name="deliveryTime"
                            label="* بازه تحویل سفارش"
                            as={
                                <TextField
                                    variant="outlined"
                                    select
                                    fullWidth
                                    disabled={values.deliveryType == ""}
                                    error={
                                        !!errors.deliveryTime && !!errors.deliveryTime
                                    }
                                >
                                    <MenuItem
                                        disabled={handleDisableTime(0)}
                                        value={"09-15"}
                                        data-cy="firstTime"
                                    >
                                        9 الی 15
                                    </MenuItem>
                                    <MenuItem
                                        disabled={handleDisableTime(15)}
                                        value={"15-21"}
                                        data-cy="firstTime"
                                    >
                                        15 الی 21
                                    </MenuItem>
                                </TextField>
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.deliveryTime &&
                                ' بازه تحویل سفارش الزامی میباشد'}
                        </FormHelperText>
                    </div>
                </div>
                <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                        <Controller
                            name="weight"
                            label="وزن سفارش(کیلوگرم)"
                            control={control}
                            rules={{
                                required: true,
                            }}
                            as={
                                <TextField
                                    type="search"
                                    variant="outlined"
                                    fullWidth
                                    id="weight"
                                    name="weight"
                                    // label="کدپیگیری"
                                    error={
                                        !!errors.weight && !!errors.weight
                                    }
                                // InputProps={{
                                //     endAdornment: (
                                //         <InputAdornment position="end">
                                //             <Tooltip title="کد دلخواه و منحصر به فرد برای هر سفارش که می‌توانید از طریق آن سفارش خود را در مراحل مختلف پیگیری نمایید">
                                //                 <Icon
                                //                     path={mdiInformationOutline}
                                //                     size={1}
                                //                     color={theme.palette.primary.main}
                                //                     className={classes.icon}
                                //                 />
                                //             </Tooltip>
                                //         </InputAdornment>
                                //     ),
                                // }}
                                />
                            }
                        />
                        <FormHelperText error focused>
                            {errors?.weight?.type === 'required' &&
                                'وزن سفارش الزامی میباشد'}
                        </FormHelperText>
                    </div>
                </div>
            </Grid>
        </>
    )
}

export default OrderInputs;